var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"featured-dorms__list dorm-card__list user__list-wrp"},[_c('container',[_c('div',{staticClass:"user__list-offer"},[_c('comments')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }